/**
 * First step of the upload modal - user selects a document type and presses Next.
 */

import Box from "@cloudscape-design/components/box"
import Button from "@cloudscape-design/components/button"
import SpaceBetween from "@cloudscape-design/components/space-between"
import Tiles from "@cloudscape-design/components/tiles"
import { useState } from "react"
import type { DtaCreationType } from "./types"

import { UPLOAD_TYPE_OPTIONS } from "./types"

const TILE_ITEMS = UPLOAD_TYPE_OPTIONS.map((option) => ({
  value: option.type,
  label: option.label,
  description: option.formatsDisplay
    ? `${option.description} Supports: ${option.formatsDisplay}`
    : option.description,
}))

interface TypeSelectStepProps {
  onNext: (type: DtaCreationType) => void
  onClose: () => void
}

export default function TypeSelectStep({ onNext, onClose }: TypeSelectStepProps) {
  const [selected, setSelected] = useState<DtaCreationType | null>(null)

  return (
    <SpaceBetween size="l">
      <Box variant="p" color="text-body-secondary">
        What type of document are you uploading?
      </Box>
      <Tiles
        columns={1}
        value={selected}
        onChange={({ detail }) => setSelected(detail.value as DtaCreationType)}
        items={TILE_ITEMS}
      />
      <Box float="right">
        <SpaceBetween direction="horizontal" size="xs">
          <Button variant="link" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            disabled={!selected}
            onClick={() => selected && onNext(selected)}
          >
            Next
          </Button>
        </SpaceBetween>
      </Box>
    </SpaceBetween>
  )
}
